<div class="container">
    <div class="row">
        <div class="col section-title-full">
            <h1>
                <span i18n>Etiquetas Ambientales</span>
            </h1>
        </div>
    </div>
</div>

<div class="container my-4">
    <div class="row">
        <div class="col">

            <p class="text-destacado text-center" i18n>Este distintivo ambiental es una etiqueta adhesiva que identifica
                los vehículos más respetuosos con el medio ambiente:</p>
            <img class="tag-img my-4" src="assets/images/etiquetas-ambientales.png" alt="etiqueta ambiental">
            <p class="text-center" i18n>El etiquetaje facilita el establecimiento y la entrada en funcionamiento de las
                tres zonas de bajas emisiones propuestas, y será útil en episodios de alta contaminación.</p>
            <p class="text-center mb-4" i18n>Existen cuatro modelos distintos, según el tipo de motor, combustible y
                antigüedad del vehículo. Los titulares de los vehículos más antiguos y contaminantes no recibirán
                distintivo ambiental alguno.</p>
            <hr>
            <h2 class="my-4" i18n>Ver los modelos de etiquetas</h2>
            <p i18n>La colocación del adhesivo es voluntaria. Aun así, se recomienda pegarlo en la parte inferior
                derecha del parabrisas a fin de permitir su visibilidad. Las administraciones con competencias en
                movilidad y medio ambiente, podrán saber la clasificación ambiental y el tipo de etiqueta que
                corresponde a cada vehículo.</p>

            <div class="accordion secondary" id="accordionTags">
                <div *ngFor="let l of labels; let i = index" class="accordion-item">
                    <h3 class="accordion-header">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                            [attr.data-bs-target]="'#collapse-' + i" aria-expanded="false" [attr.aria-controls]="'collapse-' + i"
                        >{{l.code}}</button>
                    </h3>
                    <div id="collapse-{{i}}" class="accordion-collapse collapse" data-bs-parent="#accordionTags">
                        <div class="row" *ngIf="l.image?.data">
                            <div class="col-4">
                                <img [src]="'data:image/svg+xml;base64,'+ l.image?.data" alt="etiqueta ambiental"/>
                            </div>
                            <div class="col-8">
                                <div class="accordion-body" i18n>{{l.description}}</div>
                            </div>
                        </div>
                        <div class="row" *ngIf="!l.image?.data">
                            <div class="col">
                                <div class="accordion-body" i18n>{{l.description}}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <h2 class="my-4" i18n>Estructura de la etiqueta ambiental</h2>

            <div class="card">
                <div class="row">
                    <div class="col-md-6 text-right">
                        <img class="img-fluid"
                            src="https://www.amb.cat/s/documents/11704/13837763/Parts_etiqueta.png/Parts_etiqueta7416.png?t=1657278835190"
                            alt="etiqueta ambiental">
                    </div>
                    <div class="col-md-6 tag-explain">
                        <ol>
                            <li i18n>Nivel de emisiones EURO del vehículo.</li>
                            <li i18n>Código QR con la siguiente información:</li>
                            <ol>
                                <li i18n>Año de matriculación.</li>
                                <li i18n>Marca y modelo.</li>
                                <li i18n>Combustible.</li>
                                <li i18n>Categoría y autonomía eléctrica.</li>
                                <li i18n>Nivel emisiones EURO.</li>
                                <li i18n>Potencial fiscal.</li>
                            </ol>
                            <li i18n>Número de etiqueta y código de barras.</li>
                            <li i18n>Número de matrícula y combustible empleado por el vehículo.</li>
                        </ol>
                    </div>
                </div>
            </div>

        </div>
    </div>
</div>
<br />